import { ComplementaryItem } from '@models/balance/ComplementaryItem'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { COMPLEMENTARY_ITEMS_URL } from '@utils/urls'

const fetchComplementaryItems = (params: TableParams) =>
  SBAPI.FetchPaginated<ComplementaryItem[]>(COMPLEMENTARY_ITEMS_URL, params)

const fetchComplementaryItemById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<ComplementaryItem>(`${COMPLEMENTARY_ITEMS_URL}/${id}`, params)

const createComplementaryItem = (complementaryItem: ComplementaryItem) =>
  SBAPI.Post(COMPLEMENTARY_ITEMS_URL, complementaryItem)

const updateComplementaryItem = (
  complementaryItem: Partial<ComplementaryItem>
) =>
  SBAPI.Put(
    `${COMPLEMENTARY_ITEMS_URL}/${complementaryItem.id}`,
    complementaryItem
  )

const deleteComplementaryItem = (complementaryItem: ComplementaryItem) =>
  SBAPI.Delete(`${COMPLEMENTARY_ITEMS_URL}/${complementaryItem.id}`)

export {
  createComplementaryItem,
  deleteComplementaryItem,
  fetchComplementaryItemById,
  fetchComplementaryItems,
  updateComplementaryItem,
}
